// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agreement{height:calc(100% - 80px)}.agreement .el-scrollbar{height:100%}.agreement .el-scrollbar .el-scrollbar__wrap{overflow-x:hidden}.agreement .agreement-content{padding:0 40px 40px 40px}", ""]);
// Exports
module.exports = exports;
